import { identifyFiles, uploadFile, downloadFile } from '@/api/largeFile.js'
export default {
  inject: ['uploadMode', 'formDisabled'],
  computed: {
    previewType() {
      if (this.formDisabledValue || this.disabled) {
        return 'check'
      } else {
        return 'normal'
      }
    },
    formDisabledValue() {
      return this.formDisabled()
    },
    uploadModeType() {
      return this.uploadMode()
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    disabled: {
      type: Boolean,
      default() {
        return false
      }
    },
    item: {
      type: Object
    },
    value: {
      type: [Object, String],
      default() {
        return {
          data: []
        }
      },
    },
  },
  data() {
    return {
      idArr: [],
      fileLength: 0,
    }
  },
  watch: {
    value(newVal) {
      this.initItemValue(newVal)
    },
    itemValue(newVal) {
      this.$emit('change', newVal)
    },
    deep: true,
    immediate: true
  },
  mounted() {
    this.initItemValue(this.value)
  },
  activated() {
    console.log('upload-activated')
    this.initItemValue(this.value)
  },
  data() {
    return {
      visible: false,
      idArr: [],
      fileLength: 0,
      itemValue: this.value
    }
  },
  methods: {
    initItemValue(val) {
      if (val) {
        if (typeof (val) === 'string') {
          this.itemValue = JSON.parse(val)
        } else if (typeof (val) === 'object') {
          this.itemValue = val
        }
      } else {
        this.itemValue = {
          data: []
        }
      }
    },
    handleError(item) {
      if (item.id && item.src) {
        downloadFile(item.id).then(thumbnail => {
          this.$set(item, 'src', this.getCurrentImage(thumbnail.data))
        })
      }
    },
    getImg() {
      if (this.itemValue && this.itemValue.data && this.itemValue.data.length) {
        this.itemValue.data.forEach(ivd => {
          if (ivd.id && !ivd.src) {
            downloadFile(ivd.id).then(thumbnail => {
              this.$set(ivd, 'src', this.getCurrentImage(thumbnail.data))
            })
          }
        })
      }
    },
    handleClosed() {
      this.visible = false
    },
    beforeUpload(file) {
      console.log(file.size / 1024 / 1024);
      const isLimitSize = file.size / 1024 / 1024 < this.size;
      const isLimit = this.uploadLimit === 1 ? true : this.itemValue.data.length < this.limit

      if (!isLimitSize) {
        this.$message.error(`上传文件大小不能超过 ${this.size}MB!`);
      }
      if (!isLimit) {
        this.$message.error(`上传文件数量不能超过 ${this.limit}!`);
      }
      return isLimitSize && isLimit
    },
    getCurrentImage(file) {
      var userAgent = navigator.userAgent
      if (userAgent.indexOf('AppleWebKit') > -1) {
        return this.getFileURL(this.base64ToBlob(file))
      } else {
        return file
      }
    },
    // base64转换为blob
    base64ToBlob(file) {
      try {
        var arr = file.split(',')
        var mime = arr[0].match(/:(.*?);/)[1]
        var bstr = atob(arr[1])
        var n = bstr.length
        var u8arr = new Uint8Array(n)
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        return new Blob([u8arr], { type: mime })
      } catch (exception) {
        console.log(exception)
        return null
      }
    },
    // 获取blobURL地址
    getFileURL(file) {
      var getUrl = null
      if (window.createObjectURL !== undefined) { // basic
        getUrl = window.createObjectURL(file)
      } else if (window.URL !== undefined) { // mozilla(firefox)
        getUrl = window.URL.createObjectURL(file)
      } else if (window.webkitURL !== undefined) { // webkit or chrome
        getUrl = window.webkitURL.createObjectURL(file)
      }
      return getUrl
    },
    handleUpload(files) {
      console.log(files)
      if (this.uploadLimit === 1) {
        this.itemValue.data = []
      }
      this.fileLength = files.length
      if (this.uploadModeType === 0) {
        this.$notify({
          title: '提示',
          message: `文件加载中`,
          iconClass: 'el-icon-loading',
          duration: 0
        })
        identifyFiles(this.fileLength).then(response => {
          this.idArr = response.data
          files.forEach(f => {
            const that = this
            const reader = new FileReader()
            reader.readAsDataURL(f)
            reader.onload = function (e) {
              that.itemValue.data.push({
                id: that.idArr[files.length - that.fileLength],
                name: f.name,
                dataUrl: e.target.result,
                src: that.getFileURL(f),
                file: f
              })
              that.fileLength--
              if (that.fileLength === 0) {
                that.$notify.closeAll()
                console.log('uploaded')
                that.$emit('handleUpdate')
              }
            }
          })
        })
      } else {
        files.forEach(f => {
          this.$notify({
            title: '提示',
            message: `文件上传中`,
            iconClass: 'el-icon-loading',
            duration: 0
          })
          const param = new FormData()
          param.append('file', f, f.name)
          uploadFile(1, param, { headers: {} }).then(response => {
            this.itemValue.data.push({
              id: response.data.id,
              name: response.data.name,
              src: this.getFileURL(f)
            })
            this.fileLength--
            this.$notify.closeAll()
            this.$notify({
              title: '成功',
              message: `上传成功`,
              type: 'success',
              duration: 3000
            })
            if (this.fileLength === 0) {
              this.$emit('handleUpdate')
            }
          })
        })
      }
    }
  },
}